<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import { ExerciseData } from "../dataTypes/exerciseData"
  import type { UserExerciseData } from "../stores/userExerciseDataStore";

  export let exerciseData:ExerciseData
  // svelte-ignore unused-export-let
  export let userExerciseData:UserExerciseData; userExerciseData;

  const dispatch = createEventDispatcher<{completed:void,next:void}>()

  function handleSubmit():void {
      dispatch('next')
  }
</script>

<div class="flex-1 flex flex-row min-h-0">
  <div class="flex-1"/>
  <div class="flex-1 flex flex-col items-center justify-center w-full h-full text-darkFore">
    {#if exerciseData.headerImage}
    <div>{@html exerciseData.headerImage}</div>
    {/if}
    <div class="block m-2">{@html exerciseData.text}</div>
    <button on:click={handleSubmit} class="btn-darkBackHigh">{exerciseData.buttonText}</button>
    {#if exerciseData.footerImage}
    <div>{@html exerciseData.footerImage}</div>
    {/if}
  </div>
  <div class="flex-1"/>
</div>

<style>
  div :global(code) {
    @apply my-3;
    @apply p-3;
    @apply block;
		@apply whitespace-pre-wrap;
    background-color: var(--color-base02);
  }

  div :global(ol) {
    @apply pl-4;
    @apply list-outside;
    @apply list-decimal;
    @apply mt-2;
    @apply mb-2;
  }

  div :global(li:not(:last-child)) {
    @apply mb-1;
  }
</style>
